<template>
  <div class="container">
    <div class="content">
      <div class="boxView">
        <div class="accountUser">到账账户</div>
        <div
          class="userId"
          @click="showPopup=true"
        >
          <img
            :src="imgPrex+backCardList[cardIndex].logoImage"
            alt
          />
          <span>{{backCardList[cardIndex].bankName}}({{backCardList[cardIndex].acctId | intercept}})</span>
        </div>
      </div>
      <div class="middleView">
        <div class="accountMoney">提现金额</div>
        <div class="moneyInput van-hairline--bottom">
          <div class="yang">￥</div>
          <van-field
            class="input"
            v-model="exMoney"
            maxlength="7"
            @input="bindKeyInput"
            type="number"
          />
        </div>
      </div>
      <div
        class="tips"
        v-show="exMoney * 1 > canWithdraw * 1"
      >输入金额超过可提现金额</div>
      <div
        class="existingMoney"
        :style="{'margin-bottom':exMoney * 1 > canWithdraw * 1?'0':''}"
      >
        <span>可提现金额</span>
        <span>¥{{canWithdraw}}</span>
        <span @click="exMoney = canWithdraw">全部提现</span>
      </div>
      <van-button
        block
        class="btn"
        text="提现"
        :disabled="exMoney=='.'||exMoney==undefined"
        @click="existing"
      />
    </div>
    <div class="rule">
      <p>最低提现金额为{{minMoney}}元</p>
      <p>预计即时到账，最迟24小时可到账</p>
    </div>
    <van-popup
      v-model="showPopup"
      position="bottom"
    >
      <div
        class="popup-common van-hairline--bottom"
        v-for="(item,index) in backCardList"
        :key="index"
        @click="cardIndex = index;showPopup = false"
      ><img
          :src="imgPrex+item.logoImage"
          alt
        />
        <span>{{item.bankName}}({{item.acctId | intercept}})</span>
      </div>
      <div
        class="popup-common"
        @click="showPopup = false"
      >取消</div>
    </van-popup>
  </div>
</template>
<script>
import { walletInfo, getBindingCardList, myShop } from "@/api/join";
export default {
  data() {
    return {
      exMoney: "",
      cardIndex: 0,
      canWithdraw: 0,
      showPopup: false,
      backCardList: [{
        acctId: "",
        backImage: "",
        bankName: "",
        cardId: "",
        custName: "",
        logoImage: "",
        mobilePhone: ""
      }],
      minMoney: "0", //用户提现最小金额 270
    };
  },
  filters: {
    intercept(val) {
      return val.slice(val.length - 4, val.length);
    },
  },
  methods: {
    bindKeyInput: function (e) {
      let price = e;
      price = price.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      price = price.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      price = price.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      price = price.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      if (price.indexOf(".") < 0 && price != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        price = parseFloat(price);
      }
      this.exMoney = price;
    },
    existing: function () {
      if (this.exMoney * 1 > this.canWithdraw * 1) {
        this.$toast("提现金额不能大于可提现金额");
        return;
      } else if (this.exMoney * 1 < this.minMoney * 1) {
        this.$toast(`提现金额小于${this.minMoney}元`);
      } else {
        this.$router.push({
          name: "extractCode",
          path: "/extractCode",
          params: {
            exMoney: this.exMoney,
            phone: this.backCardList[this.cardIndex].mobilePhone,
            acctId: this.backCardList[this.cardIndex].acctId,
            cardId: this.backCardList[this.cardIndex].cardId,
          },
        });
      }
    },
  },
  created() {
    getBindingCardList({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.backCardList = res.content;
      }
    });
    myShop({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.canWithdraw = res.content.canWithdraw;
      }
    });
    walletInfo({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.minMoney = res.content.minMoney;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 15px 12px 0;
  padding: 0 15px 20px;
  background-color: #fff;
  border-radius: 10px;
}
.boxView {
  height: 73px;
  display: flex;
  font-size: 15px;
}
.accountUser {
  width: 95px;
  height: 73px;
  line-height: 73px;
}
.userId {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    display: inline-block;
    top: 50%;
    margin-top: -5px;
    right: 4px;
    width: 8px;
    height: 8px;
    border-top: 1px solid #a4a4a4;
    border-left: 1px solid #a4a4a4;
    background: 0 0;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}
.middleView {
  padding-top: 10px;
}
.accountMoney {
  font-size: 15px;
}
.moneyInput {
  display: flex;
  align-items: center;
  padding-top: 20px;
}
.yang {
  font-size: 30px;
  font-weight: bold;
}
.input {
  width: 100%;
  font-size: 35px;
  font-weight: bold;
  padding-top: 7px;
  padding-left: 7px;
}
.existingMoney {
  height: 36px;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 20px;
  span:nth-child(2) {
    margin-left: 10px;
    margin-right: 44px;
  }
  span:nth-child(3) {
    width: 80px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    font-size: 15px;
    color: #187fe6;
    text-align: center;
  }
}
.van-button {
  width: 100%;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(204, 204, 204, 1);
  border-radius: 10px;
}
.tips {
  height: 20px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ff1310;
}
.rule {
  font-size: 14px;
  color: #666666;
  background-color: #f5f5f5;
  padding: 12px 27px 0;
  p:last-child {
    padding-top: 4px;
  }
}
.btn {
  width: 321px;
  height: 40px;
  color: #ffffff;
  background-color: #50BE4C;
  border-radius: 50px;
}
.van-button--disabled {
  color: #ffffff;
  background-color: #cccccc;
  opacity: 1;
}
.popup-common {
  width: 335px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333333;
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  span {
    font-size: 15px;
    color: #1d1d1d;
  }
}
</style>